import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  trackingBaseUrl: '',
  name: '',
  description: '',
  processingSystem: 'ShipEngine',
  carrierCode: '',
  tplCarrierId: '',
  apiKey1: '',
  apiKey2: '',
  apiKey3: '',
  authToken: '',
  refreshToken: '',
  expiresUtcDateTime: null,
  shipEngineCarrierId: ''
};

let defaultFilters = {
  name: '',
  processingSystem: '',
  carrierCode: '',
  tplCarrierId: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};